import { TFunction } from "i18next";
import * as yup from "yup";

import { ProgramType } from "../Program";
import { ResolutionDocumentType } from "./ResolutionDocumentType";

export interface ResolutionDocumentValidationSchemeProps {
  t: TFunction;
}

export const ResolutionDocumentValidationScheme = ({
  t,
}: ResolutionDocumentValidationSchemeProps) => {
  const requiredMsg = t("validations.required");
  const now = new Date();
  const documentTooBig = t("errorCode.Document.TooBig");
  const documentWrongFormat = t("imagesAndPdfTooltip");
  const processingDeadlineMsg = t("validations.invalidProcessingDeadline");
  const isUnlockRequestDocumentType = (documentTypeId: ResolutionDocumentType): boolean =>
    documentTypeId === ResolutionDocumentType.UnlockRequestASOO ||
    documentTypeId === ResolutionDocumentType.UnlockRequestMZO ||
    documentTypeId === ResolutionDocumentType.HarmonizationUnlockRequestASOO;
  const requiresComment = (documentTypeId: ResolutionDocumentType): boolean =>
    documentTypeId === ResolutionDocumentType.ExecutionResolution ||
    documentTypeId === ResolutionDocumentType.InstitutionBasicDataChangeResolution ||
    isUnlockRequestDocumentType(documentTypeId);

  return yup.object().shape({   
    classificationMark: yup.string().nullable(),
    registryNumber: yup.string().nullable(),
    resolutionDocument:
      yup.mixed().when("documentTypeId", {
        is: isUnlockRequestDocumentType,
        then: yup.mixed().nullable().test('resolutionDocument', documentTooBig, val => {
          if (!val) {
            return true;
          }
          if (val && val.id !== -1) {
            return true;
          }
          if (val && val.file.size <= 10485760) {
            return true;
          }
          return false;
        }).test('resolutionDocument', documentWrongFormat, val => {
          if (!val) {
            return true;
          }
          if (val) {
            var split = val.fileName.split('.');
            var ext = split[split.length - 1];

            if (ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp") {
              return true;
            }
          }
          return false;
        }),
        otherwise: yup.mixed().required(requiredMsg).test('resolutionDocument', documentTooBig, val => {
          if (val && val.file.size <= 10485760) {
            return true;
          }
          return false;
        }).test('resolutionDocument', documentWrongFormat, val => {
          if (val) {
            var split = val.fileName.split('.');
            var ext = split[split.length - 1];

            if (ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp") {
              return true;
            }
          }
          return false;
        })
      }),
    description: yup.string().when("documentTypeId", (documentTypeId, schema) => {
      if (requiresComment(documentTypeId)) {
        return yup.string().required(requiredMsg);
      } else {
        return schema;
      }
    }),
    issueDate: yup.date().required(requiredMsg).max(now, ""),
    dateFrom: yup.date().when("documentTypeId", (documentTypeId, schema) => {
      if (false) {
        return yup.date().required(requiredMsg);
      } else {
        return schema;
      }
    }),
    dateTo: yup.date().when("documentTypeId", (documentTypeId, schema) => {
      if (false) {
        return yup.date().required(requiredMsg);
      } else {
        return schema;
      }
    }),
    processingDeadline: yup.number().nullable().when("documentTypeId", {
      is: isUnlockRequestDocumentType,
      then: yup.number().test('processingDeadline', requiredMsg, val => {
        if (val === null || val === undefined) {
          return false;
        }
        return true;
      }).test('processingDeadline', processingDeadlineMsg, val => {
        if (val && val !== null && ((val >= 1 && val <= 30) || val === 60 || val === 90)) {
          return true;
        }
        return false;
      }),
      otherwise: yup.number().nullable()

    })
  });
};